const byPropKey = (propertyName, value) => () => ({
    [propertyName]: value,
});

export default byPropKey;


// WEBPACK FOOTER //
// ./src/constants/utils.js